import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import useAuthentication from 'hooks/use-authentication';
const ExamsApolloClient = ({ children }) => {
    const { getSessionToken } = useAuthentication();
    const httpLink = createHttpLink({ uri: process.env.REACT_APP_SUMADI_EXAMS_API });
    const authLink = setContext((_, { headers }) => {
        // get the authentication token from local storage if it exists
        const token = getSessionToken();
        // return the headers to the context so httpLink can read them
        return {
            headers: Object.assign(Object.assign({}, headers), { authorization: token ? `Bearer ${token}` : '' })
        };
    });
    const client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache(),
    });
    return _jsx(ApolloProvider, Object.assign({ client: client }, { children: children }), void 0);
};
export default ExamsApolloClient;
